// Libs
import { useState } from 'react';
import awesomeDebouncePromise from 'awesome-debounce-promise';
// App
import { AxiosResponse } from 'axios';
import useConstant from 'use-constant';
import { SearchHookResponse } from './search-hook.interfaces';

export * from './search-hook.interfaces';

/**
 * Hook for handling search
 * Designed to be used with autocompletes
 * @param props
 */
const useSearch = <Data>(searchApiFetcher: (keywords: string, ...args: unknown[]) => Promise<AxiosResponse>): SearchHookResponse<Data> => {
  const [isLoading, setLoading] = useState(null);
  const [results, setResults] = useState([]);

  const debouncedSearch = useConstant(() => {
    return awesomeDebouncePromise(searchApiFetcher, 1000)
  });

  const execute = async (keywords: string, ...args: unknown[]) => {
    if (keywords) {
      setLoading(true);

      const response = await debouncedSearch(keywords, ...args);

      response && response.data && setResults(response.data);

      setLoading(false);
    }
  };

  return {
    executeSearch: execute,
    searchResults: results,
    isSearchLoading: isLoading,
  };
};

export default useSearch;
